import Button from '@components/Button'
import RainbowTextField from '@components/RainbowTextField/RainbowTextField'
import { Titlebar } from '@components/Titlebar/Titlebar'
import { useContacts } from '@plug-core/state'
import { Stack } from '@mui/material'
import React, { FC, useEffect, useMemo, useState } from 'react'
import addressMatcher, { AddressType } from '@plug-core/utils/addressMatcher'
import { useTranslation } from 'react-i18next'

interface Params {
  address: string
  close: () => void
  onSave?: (newAddress: string) => void
}

const ContactForm: FC<Params> = ({ address: initialAddress, close, onSave }) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'contactForm' })
  const { addContact, updateContact, getContactByAddress, removeContact } = useContacts()

  const existingContact = useMemo(() => getContactByAddress(initialAddress), [])

  const [address, setAddress] = useState(initialAddress)
  const [name, setName] = useState(existingContact?.name || '')

  const addressType = addressMatcher(address)
  const addressInvalid = address ? addressType === AddressType.Invalid : false

  const handleSave = () => {
    const contact = existingContact || getContactByAddress(address)

    if (contact) {
      updateContact(contact.address, { name, address })
    } else {
      addContact({ name, address, avatar: '🥸' })
    }

    onSave?.(address)
    close()
    setName('')
    setAddress('')
  }

  const handleDelete = () => {
    removeContact(existingContact!)
    close()
  }

  return (
    <Stack spacing={2} p={2}>
      <Titlebar title={existingContact ? t('edit') : t('add')} />
      <RainbowTextField
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={t('name')}
      />
      <RainbowTextField
        error={addressInvalid}
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        placeholder={t('address')}
      />
      <Stack direction="row" spacing={2}>
        {existingContact && (
          <Button fullWidth onClick={handleDelete} variant="outlined">
            {t('delete')}
          </Button>
        )}
        <Button
          fullWidth
          onClick={handleSave}
          disabled={!name || !address || addressInvalid}
          variant="rainbow"
        >
          {t('save')}
        </Button>
      </Stack>
    </Stack>
  )
}

export default ContactForm
